import React from 'react'
import Button from '../../atoms/button/Button'
import Text from '../../atoms/text/Text'
import Image from '../../atoms/image/Image'
import VerticalGroup from '../../atoms/verticalgroup/VerticalGroup'

interface Props {
  round: number
  handleClick: () => void
  logo?: string
  gameName?: string
}

const RoundResultsSummary: React.FC<Props> = ({ round, handleClick, logo, gameName }) => {
  return (
    <VerticalGroup full verticalCenter center wide>
      <Image src={logo} alt='default logo' heightSize={56} className='logo'></Image>
      <Text size="3xl" className='w-88' bold center colour='white'>{gameName}</Text>
      <Text size="5xl" className='mt-8 mb-4' bold colour='white'>ROUND {round} SUMMARY</Text>
      <Button onClick={handleClick} wide large style={{ fontWeight: 'bold', fontSize: '0.9rem' }}>SEE RESULTS</Button>
    </VerticalGroup>
  )
}

export default RoundResultsSummary